import { CertFetcher } from "./fetcher_browser.js";
import { KeyChainCertSource } from "./keychain_browser.js";
import { TrustAnchorContainer } from "./trust-anchor-container_browser.js";
/** Find certificates from multiple sources. */
export class CertSources {
    trustAnchors;
    fetcher;
    keyChainSource;
    list;
    constructor(opts) {
        const { trustAnchors = [], keyChain, offline = false, } = opts;
        this.trustAnchors = Array.isArray(trustAnchors) ? new TrustAnchorContainer(trustAnchors) : trustAnchors;
        this.list = [this.trustAnchors];
        if (keyChain) {
            this.keyChainSource = new KeyChainCertSource(keyChain);
            this.list.push(this.keyChainSource);
        }
        if (!offline) {
            this.fetcher = new CertFetcher(opts);
            this.list.push(this.fetcher);
        }
    }
    /**
     * Find certificates by certificate name or key name.
     *
     * @remarks
     * Searching from sources in this order:
     * - trust anchors
     * - local KeyChain
     * - network retrieval
     * After finding one or more certificates in a source, subsequent sources are skipped.
     */
    async *findCerts(keyLocator) {
        for (const s of this.list) {
            let found = false;
            for await (const cert of s.findCerts(keyLocator)) {
                yield cert;
                found = true;
            }
            if (found) {
                break;
            }
        }
    }
    isTrustAnchor(cert) {
        return this.trustAnchors.has(cert);
    }
}
